import { CommonModule } from '@angular/common';
import { Component, Optional, signal, Signal, OnInit, OnDestroy } from '@angular/core';
import { SvgComponent } from '@app/components/shared/svg/svg.component';
import { SettingsService } from '@app/_services/settings.service';
import { Subject, takeUntil } from 'rxjs';
import { AnalyticsService } from '@app/_services/analytics.service';
import { StorageService } from '@app/_services/storage.servive';
import { AnalyticsScreen } from '@app/_types/analytics-events.types';
import { MatDialogRef } from '@angular/material/dialog';
import { CustomBottomSheetRef } from '@app/_services/custom-bottom-sheet.service';
import { environment } from '@environments/environment';

@Component({
    selector: 'app-insight',
    imports: [
        CommonModule,
        SvgComponent
    ],
    templateUrl: './insight.component.html',
    styleUrl: './insight.component.scss'
})

export class InsightComponent implements OnInit, OnDestroy {

  screenEnterTime: Signal<Date> = signal(new Date());
  unSubscribe = new Subject<void>();

  appStoreLink: string = environment.appStoreLink
  playStoreLink: string = environment.playStoreLink

  constructor(
    @Optional() public dialogRef: MatDialogRef<InsightComponent> | null,
    @Optional() public bottomSheetRef: CustomBottomSheetRef<InsightComponent> | null,
    public ss: SettingsService,
    private as: AnalyticsService,
    private storageService: StorageService,
  ) {
    dialogRef?.backdropClick().subscribe(async () => {
      this.closeDialog();
    });

    bottomSheetRef?.backdropClick().subscribe(async () => {
      this.closeDialog();
    });
  }

  openPlayStore() {
    window.open(this.playStoreLink, '_blank');
  }

  openAppStore() {
    window.open(this.appStoreLink, '_blank');
  }


  private close(result?: any): void {
    if (this.dialogRef) {
      this.dialogRef.close(result);
    } else if (this.bottomSheetRef) {
      this.bottomSheetRef.dismiss(result);
    }
  }

  closeDialog() {
    this.close();
  }

  
  ngOnInit() {
    this.analyticsInit();
  }

  analyticsInit() {
    this.as.analytics$.pipe(takeUntil(this.unSubscribe)).subscribe((init: boolean) => {
      if (init) {
        const previousScreen = this.storageService.getCurrentScreen() as AnalyticsScreen;
        this.as.screenViewEvent('drawerInsights', 'today');
        this.storageService.setCurrentScreen('drawerInsights');
      }
    });
  }

  ngOnDestroy() {
    this.as.screenExitEvent('drawerInsights', this.screenEnterTime());
    this.unSubscribe.next();
    this.unSubscribe.complete();
  }
}
